import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EAlertType } from '../../types/authenticationWidget/alertType';
import { EHeadingType } from '@cian/authentication-widget';

export interface IAuthenticationWidgetState {
  userId?: number;
  autoRefresh: boolean;
  alert: EAlertType | null;
  // нужно, чтобы сохранить логику установки начальной вьюхи в контексте авторизации
  useDefaultView: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewData: any & {
    headingType: EHeadingType;
  };
  // откуда была запрошена авторизация
  source: string | null;
  // если true, будет запрашиваться авторизация (пока работает только на megalanding)
  authorizationRequired: boolean;
}

export const initialState: IAuthenticationWidgetState = {
  autoRefresh: true,
  alert: null,
  useDefaultView: false,
  viewData: {
    headingType: EHeadingType.ToJoinOta,
  },
  source: null,
  authorizationRequired: true,
};

const authenticationWidgetSlice = createSlice({
  name: 'authenticationWidgetSlice',
  initialState,
  reducers: {
    setAuthenticationWidgetData: (
      state,
      action: PayloadAction<Omit<IAuthenticationWidgetState, 'authorizationRequired'>>,
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const {
  reducer: authenticationWidgetReducer,
  actions: { setAuthenticationWidgetData },
} = authenticationWidgetSlice;
